import { useEffect, useState, useRef } from 'react'
import { Box, Button, TextField, Typography, Paper, Fab, FormControlLabel, Checkbox, Switch, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, CircularProgress } from '@mui/material'
import { AddCircleOutlineOutlined, AddOutlined, CreateOutlined, EditOutlined, GroupAddOutlined, GroupOutlined, Height, InfoOutline, ListAltOutlined, ListOutlined, NoteAddSharp, NotesOutlined, Padding, WrongLocation } from '@mui/icons-material'
import { getSupabase } from './supabaseClient'
import React from 'react'
import LoadingPageSpinner from './LoadingPageSpinner'
const supabase = getSupabase()
export interface ListMember {
    email: string,
    name: string,
    phone_nbr: string,
    isOnlyFriend_NOT_STORED: boolean
}

interface SignupProps {
    userMail: string
}

export default function SignupForm({ userMail }: SignupProps) {
    const [memberList, setMemberList] = useState<ListMember[]>([{ email: userMail, name: '', phone_nbr: '', isOnlyFriend_NOT_STORED: false }])
    const [userEmptyFields, setUserEmptyFields] = useState(false);
    const [showCreateListButton, setShowCreateListButton] = useState(false);
    const [createListExpanded, setCreateListExpanded] = useState(false);
    const [alertState, setAlertState] = useState({ title: '', text: '', open: false })
    const [confirmListDialogOpen, setConfirmListDialogOpen] = useState(false);
    const [creatingList, setCreatingList] = useState(false);

    const hasEmptyFields = (member: ListMember) => Object.values([member.name, member.email, member.phone_nbr]).some(v => v.trim() === '');

    const updateMember = (
        fieldName: keyof ListMember,
        value: any,
        index: number
    ) => {
        setMemberList(prev =>
            prev.map((member, i) =>
                i === index ? { ...member, [fieldName]: value } : member
            )
        );
    };


    useEffect(() => {
        // setUserEmptyFields(hasEmptyFields(memberList[0]));
        if (userEmptyFields) {
            setShowCreateListButton(false);
            return;
        }
        if (memberList.length > 1) {
            // setShowCreateListButton(!memberList.some(hasEmptyFields));
            setShowCreateListButton(true);
            setCreateListExpanded(true)

        }
    }, [memberList])

    // useEffect(() => {
    //     if (showCreateListButton) {
    //         setCreateListExpanded(true)
    //     }
    // }, [showCreateListButton])

    const handleAddMember = () => {
        setMemberList(prev => [...prev, { email: '', name: '', phone_nbr: '', isOnlyFriend_NOT_STORED: false }])
    }

    const handleRemoveMember = (index: number) => {
        setMemberList(memberList.filter((_m, i) => i !== index))
    }

    const handleCreateClick = () => {
        if (memberList.some(hasEmptyFields)) {
            setAlertState({ title: "Tomma fält", text: "Alla fält måste vara ifyllda!", open: true })
            return;
        }

        const wrongEmailMember = memberList.find(m => !m.email.includes("@"));
        if (wrongEmailMember !== undefined) {
            setAlertState({ title: "Ogilitig mejladress", text: `${wrongEmailMember.name} saknar "@" i sin mejladress.`, open: true })
            return;
        }

        const missingCountryCodeInPhoneNbrMember = memberList.find(m => !m.phone_nbr.includes("+"));
        if (missingCountryCodeInPhoneNbrMember !== undefined) {
            setAlertState({ title: "Ogiltigt telefonnummer", text: `${missingCountryCodeInPhoneNbrMember.name}s telefonnummer saknar landskod (måste börja med +).`, open: true })
            return;
        }

        setConfirmListDialogOpen(true);
    }

    const createList = async () => {
        setCreatingList(true);
        setConfirmListDialogOpen(false);

        const rows = memberList.map(m => ({
            email: m.email,
            name: m.name,
            phone_nbr: m.phone_nbr
        }));

        const { data, error } = await supabase.rpc(
            'create_list_with_members',
            {
                for_friends: memberList.some(m => m.isOnlyFriend_NOT_STORED),
                members: rows
            }
        );

        if (error) {
            setAlertState({
                title: "Aj då!",
                text: "Något gick fel när vi försökte skapa listan. Kontakta ida@bergenholtz.se för felcheck eller försök igen.",
                open: true
            });
            setCreatingList(false);
            return;
        }

        // Success → redirect
        window.location.href = `/list/${data.list.id}`;
    };

    if (creatingList) {
        <LoadingPageSpinner />
    }

    return (
        <Box
            style={memberList.length < 2 ? {
                height: '100dvh', // Dynamic viewport height for mobile browsers
                overflow: 'hidden' // Prevents any overflow scrolling
            } : {
                overflow: 'scroll',
                height: '110vh'
            }}
            sx={{

                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                gap: 2,
                justifyContent: 'center',
                backgroundColor: '#f5f5f5',

            }}
        >
            <AlertDialog
                title={alertState.title}
                text={alertState.text}
                open={alertState.open}
                onClose={() => setAlertState({ title: "", text: "", open: false })}
            />
            <ConfirmListDialog
                memberList={memberList}
                open={confirmListDialogOpen}
                onClose={() => setConfirmListDialogOpen(false)}
                onConfirm={createList}
            />
            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: '4px',

                }}
            >
                <GroupOutlined />
                <Typography variant="h5" align="center">
                    Ny listgrupp
                </Typography>
            </div>

            {userEmptyFields && (
                <MemberForm
                    name={memberList[0].name}
                    email={memberList[0].email}
                    phone={memberList[0].phone_nbr}
                    isOnlyFriend={memberList[0].isOnlyFriend_NOT_STORED}
                    formIndex={0}
                    onMemberChange={updateMember}
                    onRemove={handleRemoveMember}
                />
            )}

            {!userEmptyFields && (memberList.map((member, ind) => (
                <MemberForm
                    name={member.name}
                    key={`member${ind}`}
                    email={member.email}
                    phone={member.phone_nbr}
                    isOnlyFriend={member.isOnlyFriend_NOT_STORED}
                    formIndex={ind}
                    onMemberChange={updateMember}
                    onRemove={handleRemoveMember}
                />
            )))}

            <div
                style={{
                    display: 'flex',
                    flexDirection: 'row',
                    alignItems: 'center',
                    gap: 4
                }}
            >
                <Fab
                    color="primary"
                    aria-label="add"
                    size={!createListExpanded ? "large" : "small"}
                    disableRipple
                    style={{ backgroundColor: '#4ea363', gap: 4 }}
                    onClick={() => createListExpanded ? setCreateListExpanded(false) : handleAddMember()}
                    variant={showCreateListButton && createListExpanded && !userEmptyFields ? 'circular' : 'extended'}
                    disabled={userEmptyFields}
                >
                    {!userEmptyFields ? (
                        <>
                            {showCreateListButton && createListExpanded ? <AddOutlined /> :
                                (
                                    <>
                                        <AddOutlined />
                                        Lägg till Listkompis
                                    </>
                                )
                            }
                        </>
                    ) : (
                        <>Fyll i ovan</>
                    )}

                </Fab>

                {/* {!userEmptyFields && showCreateListButton && ( */}
                {memberList.length > 1 && (
                    <Fab
                        color="primary"
                        aria-label="add"
                        size={createListExpanded ? "large" : "medium"}
                        disableRipple
                        style={{ backgroundColor: '#4e6ca3', gap: 4 }}
                        onClick={() => !createListExpanded ? setCreateListExpanded(true) : handleCreateClick()}
                        variant={!createListExpanded ? 'circular' : 'extended'}
                    >
                        {createListExpanded ? (
                            <>
                                <GroupAddOutlined />
                                Skapa listgrupp
                            </>
                        ) : (
                            <GroupAddOutlined />
                        )}
                    </Fab>
                )}

            </div>

        </Box>
    )
}

interface FormProps {
    name: string,
    email: string,
    phone: string,
    formIndex: number,
    isOnlyFriend: boolean,
    onMemberChange: (fieldName: keyof ListMember, value: string, index: number) => void;
    onRemove: (index: number) => void;
}

function MemberForm({ name, email, phone, formIndex, isOnlyFriend, onMemberChange, onRemove }: FormProps) {
    const [dispName, setDispName] = useState(name);
    const [emailAdr, setEmailAdr] = useState(email);
    const [phoneNbr, setPhoneNbr] = useState(phone.length > 0 ? phone : "+46");
    const [infoOpen, setInfoOpen] = useState(false)


    const commit = (field: keyof ListMember, value: any) => {
        onMemberChange(field, value, formIndex);
    };

    useEffect(() => {
        if (phoneNbr.length > 11) commit("phone_nbr", phoneNbr);
        if (emailAdr.includes("@") && formIndex > 0) commit("email", email);
        if (dispName.length > 2) commit("name", dispName);
    }, [dispName, emailAdr, phoneNbr]);


    return (
        <Paper
            sx={{
                p: 3,
                width: '100%',
                maxWidth: 250,
                display: 'flex',
                flexDirection: 'column',
                borderRadius: 10,
                gap: 2,
            }}
            elevation={3}
        >
            <Typography variant="subtitle1" align="center">
                {formIndex === 0 ? "Du" : `Listkompis${isOnlyFriend ? '' : ' / Älskling'}${formIndex === 1 ? '' : ` ${formIndex}`}`}
            </Typography>
            
            <TextField
                label="Visningsnamn"
                value={dispName}
                size='small'
                placeholder='typ Gunhild'
                onInput={(e) => {
                    const target = e.target as HTMLInputElement;
                    setDispName(target.value);
                }}
                onBlur={() => commit('name', dispName)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        commit('name', dispName);
                    }
                }}
                fullWidth
            />
            <TextField
                label="Mejl"
                placeholder='t.ex a@b.se'
                size='small'
                disabled={formIndex === 0}
                value={emailAdr}
                helperText={formIndex === 0 ? "" : "Används för inloggning!"}
                onInput={(e) => {
                    if (formIndex > 0) {
                        const target = e.target as HTMLInputElement;
                        setEmailAdr(target.value);
                    }
                }}
                onBlur={() => {
                    if (formIndex > 0) {
                        commit('email', emailAdr);
                    }
                }}
                onKeyDown={(e) => {
                    if (e.key === 'Enter' && formIndex > 0) {
                        commit('email', emailAdr);
                    }
                }}
                fullWidth
            />


            <TextField
                label="Telefonnummer"
                type="tel"
                size='small'
                value={phoneNbr.length > 0 ? phoneNbr : '+46'}
                error={!phoneNbr.includes("+")}
                helperText={!phoneNbr.includes("+") ? "Telefonnummer måste börja med +" : "Används för Whatsapp-notifikationer!"}
                onInput={(e) => {
                    const target = e.target as HTMLInputElement;
                    setPhoneNbr(target.value);
                }}
                onBlur={() => commit('phone_nbr', phoneNbr)}
                onKeyDown={(e) => {
                    if (e.key === 'Enter') {
                        commit('phone_nbr', phoneNbr);
                    }
                }}
                fullWidth
            />

            {/* {formIndex === 0 && (
                <div
                          style={{
                            border: "dashed",
                            display: 'flex',
                            flexDirection: 'row',
                            alignItems: 'center',
                            alignSelf: 'center',
                            borderColor:'#746b6b79',
                            gap: 10,
                            padding: 4,
                            borderRadius: 10,
                            width: 180,
                            marginTop:-5
                          }}
                          onClick={() => setInfoOpen(true)}
                        >
                          <InfoOutline style={{color:"#555c6ba6", width:18}}></InfoOutline>
                          <Typography style={{color:"#555c6bda"}} sx={{ lineHeight: 1.2, fontSize: 12 }}>Information om lagring av personlig data</Typography>
                
                        </div>
            )} */}

            

            {formIndex > 0 && (
                <FormControlLabel
                    style={{ alignSelf: 'flex-end', marginTop: -10 }}
                    label={<Typography variant="body1" sx={{ fontSize: '0.875rem', fontWeight: 400 }}>Är bara kompis</Typography>}
                    control={
                        <Switch
                            checked={isOnlyFriend}
                            onChange={(e) => { commit("isOnlyFriend_NOT_STORED", e.target.checked) }}
                            sx={{
                                '& .MuiSwitch-switchBase.Mui-checked': {
                                    color: '#5ca066', // Thumb color when checked
                                    '& + .MuiSwitch-track': {
                                        backgroundColor: '#48946a', // Track color when checked
                                    },
                                },
                            }}
                        />
                    }
                    labelPlacement='start'
                />
            )}

            {formIndex > 1 && (
                <Button onClick={() => onRemove(formIndex)}>
                    Ta bort
                </Button>
            )}


        </Paper>
    )
}

interface AlertProps {
    title: string, text: string, open: boolean, onClose: () => void
}

function AlertDialog({ title, text, open, onClose }: AlertProps) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            sx={{
                '& .MuiDialog-paper': {
                    borderRadius: 3, // Makes the dialog more rounded
                }
            }}
        >
            <DialogTitle id="alert-dialog-title">
                {title}
            </DialogTitle>
            <DialogContent>
                <DialogContentText id="alert-dialog-description">
                    {text}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} autoFocus>
                    Okej
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface ConfirmListProps {
    memberList: ListMember[]
    open: boolean,
    onClose: () => void
    onConfirm: () => void
}

function ConfirmListDialog({ memberList, open, onClose, onConfirm }: ConfirmListProps) {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="confirm-dialog-title"
            aria-describedby="confirm-dialog-description"
            sx={{
                '& .MuiDialog-paper': {
                    borderRadius: 8, // Makes the dialog more rounded
                    maxWidth: 400,
                    p: 1
                }
            }}
        >
            <DialogTitle >
                Stämmer allt?
            </DialogTitle>
            <DialogContent>
                <div
                    style={{ display: 'flex', flexDirection: 'column', gap: 10, alignItems: 'flex-start', paddingLeft: 2 }}
                // sx={{paddingLeft:1}}

                >
                    {memberList.map((m, i) => (
                        <React.Fragment key={`confirm_member_${i}`}>
                            <Typography variant='subtitle1' style={{ fontWeight: 700 }}>
                                Listmedlem {i + 1}
                            </Typography>

                            <Box style={{ display: 'flex', flexDirection: 'column', gap: 2 }} sx={{ paddingLeft: 2 }}>
                                <MemberItem fieldKey="Namn" fieldValue={m.name} />
                                <MemberItem fieldKey="Mejl" fieldValue={m.email} />
                                <MemberItem fieldKey="Telefon" fieldValue={m.phone_nbr} />
                                {m.isOnlyFriend_NOT_STORED && (
                                    <MemberItem fieldKey="Relation" fieldValue="bara kompis" />
                                )}
                            </Box>
                        </React.Fragment>
                    ))}
                    {memberList.some(m => m.isOnlyFriend_NOT_STORED) ? (
                        <MemberItem fieldKey="Grupprelation" fieldValue="vänner/familj" />
                    ) : (
                        <MemberItem fieldKey="Grupprelation" fieldValue="glada i varandra" />
                    )}
                </div>

            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>
                    Avbryt
                </Button>
                <Button variant="contained" onClick={onConfirm} autoFocus>
                    <AddOutlined />
                    Skapa lista
                </Button>
            </DialogActions>
        </Dialog>
    )
}

interface MemberItemProps {
    fieldKey: string,
    fieldValue: string
}

function MemberItem({ fieldKey, fieldValue }: MemberItemProps) {
    return (
        <div
            style={
                {
                    display: 'flex',
                    flexDirection: 'row',
                    gap: 2
                }
            }
        >
            <Typography variant='caption'>{fieldKey}:</Typography>
            <Typography variant='body2'>{fieldValue}</Typography>
        </div>
    )
}
